import styled from 'styled-components'
import { H3 } from '../styled/typography/typography'
import FlexAlignCenter from '../styled/FlexAlignCenter'

export const AlertWrapper = styled.div`
  text-align: center;
  padding: 22px 0;
`

export const Header = styled(H3)`
  margin: ${props => props.tight ? '0 0 8px' : '25px'};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`

export const Divider = styled.div`
  margin-top: 36px;
  margin-bottom: 22px;
  width: 100%;
  border-top: 1px solid #EEE;
`

export const BottomButtons = styled(FlexAlignCenter)`
  width: 80%;
  margin: 0 auto;
  justify-content: center;
  gap: 15px;

  & > * {
    flex: 1;
  }
`
